import { createSlice } from "@reduxjs/toolkit";
import { defaultPrompts } from "../constants/prompts";

export const promptSlice = createSlice({
  name: "prompts",
  initialState: {
    value: defaultPrompts
  },
  reducers: {
    updatePrompts: (state, action) => {
      state.value = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  updatePrompts,
} = promptSlice.actions;

export default promptSlice.reducer;
